import React from 'react';
import { useTranslation } from '../contexts/TranslationContext';

function Footer() {
  const { t } = useTranslation();

  return (
    <div className="footer">
      <div className="social-links">
        <h3>{t('followUs') || 'Follow Us on Social Media'}</h3>
        <div className="social-icons">
          <a
            href="https://www.facebook.com/inCruises/"
            target="_blank"
            rel="noopener noreferrer"
            className="social-link"
          >
            <img
              src="https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/t-circle-white/facebook@2x.png"
              width="32"
              height="32"
              alt="Facebook"
              title="Facebook"
            />
          </a>
          <a
            href="https://twitter.com/incruises"
            target="_blank"
            rel="noopener noreferrer"
            className="social-link"
          >
            <img
              src="https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/t-circle-white/twitter@2x.png"
              width="32"
              height="32"
              alt="Twitter"
              title="Twitter"
            />
          </a>
          <a
            href="https://www.instagram.com/incruises/"
            target="_blank"
            rel="noopener noreferrer"
            className="social-link"
          >
            <img
              src="https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/t-circle-white/instagram@2x.png"
              width="32"
              height="32"
              alt="Instagram"
              title="Instagram"
            />
          </a>
          <a
            href="https://www.youtube.com/c/IncruisesOfficial"
            target="_blank"
            rel="noopener noreferrer"
            className="social-link"
          >
            <img
              src="https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/t-circle-white/youtube@2x.png"
              width="32"
              height="32"
              alt="YouTube"
              title="YouTube"
            />
          </a>
          <a
            href="https://www.pinterest.com/incruisesinternational/"
            target="_blank"
            rel="noopener noreferrer"
            className="social-link"
          >
            <img
              src="https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/t-circle-white/pinterest@2x.png"
              width="32"
              height="32"
              alt="Pinterest"
              title="Pinterest"
            />
          </a>
          <a
            href="https://www.linkedin.com/company/incruises™"
            target="_blank"
            rel="noopener noreferrer"
            className="social-link"
          >
            <img
              src="https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/t-circle-white/linkedin@2x.png"
              width="32"
              height="32"
              alt="LinkedIn"
              title="LinkedIn"
            />
          </a>
        </div>
      </div>
      <div className="footer-info">
        <p>{t('footerCopyright') || '© 2015–present inGroup International. All rights reserved.'}</p>
        <p>{t('footerAddress') || 'St. 1- Lot #3, Suite 500 (Metro Office Park 3) Guaynabo, Puerto Rico 00968-1705'}</p>
      </div>
    </div>
  );
}

export default Footer;



